export default "__VITE_ASSET__DDbhQWoX__"